/**
 * Fold a string for account searching: strip accents, lowercase, and drop every
 * separator, so `hopital` matches `Hôpital` and `cisssca montmagny` matches
 * `CISSSCA - Montmagny`. Mirrors the normalisation the quote form already uses to
 * match an account by name.
 */
function foldForSearch(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}

/**
 * Does the account row the user can SEE match what they typed?
 *
 * Deliberately a substring test on the visible label rather than cmdk's fuzzy
 * `defaultFilter`. The account combobox has to give each row the account id as its
 * cmdk `value`, because a duplicate value collapses into a single item and 9 live
 * accounts are named exactly "Acces Pharma". But `defaultFilter` concatenates the
 * value and keywords before scoring, so the id's hex digits become searchable:
 * typing `13` scored an account whose id merely contained "13" above
 * "0013 Acces Pharma", and since cmdk re-sorts by score and auto-highlights the
 * first row, Enter selected an unrelated customer onto a commercial document.
 *
 * Matching the label by substring instead guarantees every row offered visibly
 * contains what was typed, so the highlighted row is never a surprise.
 */
export function accountLabelMatchesSearch(label: string, search: string): boolean {
  const needle = foldForSearch(search);
  if (!needle) return true;
  return foldForSearch(label).includes(needle);
}
